import { Col, List, Row, Typography } from 'antd';

type Props = {
    label: string;
    currencySymbol: string;
    amount: number;
};

const TotalsListItem = ({ label, currencySymbol, amount }: Props) => {
    return (
        <List.Item>
            <Row justify="space-between" style={{ width: '100%', paddingInline: 10 }}>
                <Col>{label}</Col>
                <Col>
                    <Typography.Text strong>
                        {currencySymbol}
                        {amount?.toFixed(2)}
                    </Typography.Text>
                </Col>
            </Row>
        </List.Item>
    );
};

export default TotalsListItem;
